/* eslint-disable */
const axios = require('axios').default;
import apiosWithToken from "./apiosWithToken"

export default {
    getUnits() {
        return apiosWithToken.get('/recipes/ingredient/unit/?limit=999999')
    },
    getIngredients() {
        return apiosWithToken.get('/recipes/ingredient/?limit=999999')
    },
    getIngredient(id) {
        return apiosWithToken.get(`/recipes/ingredient/${id}`)
    },
    getCategories() {
        return apiosWithToken.get('/recipes/categories/')
    },
    createIngredient(payload) {
        return apiosWithToken.post('/recipes/ingredient/', payload)
    },
    updateIngredient(payload) {
        return apiosWithToken.put(`/recipes/ingredient/${payload.id}/`, payload)
    },
    createIngredientGroup(payload) {
        return apiosWithToken.post('/recipes/ingredient/', payload)
    },
    getOptions() {
        return apiosWithToken.get(`/recipes/options/`)
    },
    getRecipe(id) {
        return apiosWithToken.get(`/recipes/recipe/${id}`)
    },
    getRecipes(data) {
        var offset = data.offset
        if (data.offset == 1) {
            offset = data.offset - 1
        } else {
            offset = data.offset - 1
            offset = offset * data.limit
        }

        var url = `/recipes/recipe/?limit=${data.limit}&offset=${offset}`

        if (data.search) {
            url = `/recipes/recipe/?limit=${data.limit}&offset=${offset}&search=${data.search}`
        }


        console.log(url)
        return apiosWithToken.get(`${url}`)
    },
    createRecipe(payload) {
        return apiosWithToken.post(`/recipes/recipe/`, payload)
    },
    updateRecipe(id, recipe) {
        return apiosWithToken.put(`/recipes/recipe/${id}/`, recipe)
    },
    createIngredientGroup(payload) {
        return apiosWithToken.post(`/recipes/ingredient/group/`, payload)
    },
    updateIngredientGroup(group) {
        return apiosWithToken.put(`/recipes/ingredient/group/${group.id}/`, group)
    },
    deleteIngredientGroup(id) {
        return apiosWithToken.delete(`/recipes/ingredient/group/${id}/`)
    },
    createIngredientGroupItem(data) {
        return apiosWithToken.post(`/recipes/ingredient/group/item/`, data)
    },
    updateIngredientGroupItem(ingredient) {
        return apiosWithToken.put(`/recipes/ingredient/group/item/${ingredient.id}/`, ingredient)
    },
    deleteIngredientGroupItem(id) {
        return apiosWithToken.delete(`/recipes/ingredient/group/item/${id}/`)
    },
    getIngredientItemNumericQuantity() {
        return apiosWithToken.get(`/recipes/ingredient/item/numeric-quantity/?limit=99999`)
    },
    createIngredientItemNumericQuantity(payload) {
        return apiosWithToken.post(`/recipes/ingredient/item/numeric-quantity/`, payload)
    },
    patchIngredientGroupItem(id, payload) {
        return apiosWithToken.patch(`/recipes/ingredient/group/item/${id}/`, payload)
    },

    createMethodGroup(payload) {
        return apiosWithToken.post(`/recipes/method/group/`, payload)
    },
    updateMethodGroup(group) {
        return apiosWithToken.put(`/recipes/method/group/${group.id}/`, group)
    },
    deleteMethodGroup(id) {
        return apiosWithToken.delete(`/recipes/method/group/${id}/`)
    },

    createMethodGroupInstruction(payload) {
        return apiosWithToken.post(`/recipes/method/instruction/`, payload)
    },
    updateMethodGroupInstruction(group) {
        return apiosWithToken.put(`/recipes/method/instruction/${group.id}/`, group)
    },
    deleteMethodGroupInstruction(id) {
        return apiosWithToken.delete(`/recipes/method/instruction/${id}/`)
    },
    patchMethodGroupInstruction(id, payload) {
        return apiosWithToken.patch(`/recipes/method/instruction/${id}/`, payload)
    },
    getDietaryOptions() {
        return apiosWithToken.get(`/recipes/dietary-preferences/?limit=20`)
    },
    getRecipesOptions() {
        return apiosWithToken.get(`/recipes/recipe/as-option/`)
    },
}